/**
 * Review totals as shown on the site. Hand-counted from the live listings, so the numbers are
 * a claim we make in public: update them when they drift, and never round up.
 *
 * Last checked 2026-09-20.
 */
export const REVIEW_COUNTS = {
  google: 48,
  facebook: 2,
} as const

export const TOTAL_REVIEWS = REVIEW_COUNTS.google + REVIEW_COUNTS.facebook

/** The Google listing. Only for pages that deliberately send people off site. */
export const GOOGLE_REVIEWS_URL = 'https://www.google.com/maps?cid=3933314338346819534'
